module.exports = __webpack_public_path__ + "static/media/MC.ef93b906.svg";